import { MdPayments } from "react-icons/md";
import { toCurrencyFormat } from "helpers/utils";
import paymentsService from "services/admin/paymentsService";
import { useDashboardQuery } from "../dashboard-utils";
import KpiCard from "./KpiCard";

const RevenueTotalAmount = ({ month }) => {
  const q = useDashboardQuery(["revenue-total", month], async () => (await paymentsService.getRevenueTotalAmount({ month })).data);

  return (
    <KpiCard
      icon={MdPayments}
      accent="green"
      label="Выручка"
      hint="Сумма оплат за выбранный период"
      to="/admin/sub-orders/payments"
      value={toCurrencyFormat(q.data?.sum, q.data?.currency)}
      loading={q.isLoading}
      fetching={q.isPlaceholderData}
      error={q.error}
      onRetry={q.refetch}
    />
  );
};

export default RevenueTotalAmount;
